/* HOLYGRADE Mobile-Drawer Overlap-Fix
   Misst die Hoehe der sticky Announcement-Bar (.utility-bar) und legt sie als
   CSS-Variable --hg-utilbar-h auf :root ab. holygrade-custom.css nutzt sie
   (<989px), um den Mobile-Menue-Drawer um genau diese Hoehe nach unten zu
   versetzen, damit der erste Eintrag nicht hinter der goldenen Bar verschwindet.
   Reine Layout-Hilfe, keine Tracking- oder SEO-Tags betroffen. */
(function () {
  function setUtilBarH() {
    try {
      var bar = document.querySelector('.utility-bar');
      var h = (bar && window.innerWidth < 990) ? Math.round(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--hg-utilbar-h', h + 'px');
    } catch (e) {}
  }
  function init() {
    setUtilBarH();
    window.addEventListener('resize', setUtilBarH, { passive: true });
    window.addEventListener('orientationchange', setUtilBarH);
    try {
      var bar = document.querySelector('.utility-bar');
      if (bar && 'ResizeObserver' in window) { new ResizeObserver(setUtilBarH).observe(bar); }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
